import * as HLF from "html-living-framework";
import { ElementData } from "../Data/ElementData";
import { ObstacleType } from "../Data/Obstacles";
import { TicketColourSuffixes } from "../GameObjects/TicketBooth";

export class RegionData {
    public readonly terrain: ElementData;
    public readonly backgrounds: ReadonlyArray<ElementData>;
    public readonly decorators: ReadonlyArray<ElementData>;
    public readonly generic: ReadonlyArray<ElementData>;
    public readonly unique: ReadonlyArray<ElementData>;
    public readonly obstacles: ReadonlyArray<ObstacleType>;
    public readonly obstacleSpacing: PIXI.Point;
    public readonly flag: ElementData;
    public readonly ticket: ElementData;
    public readonly ticketColours: TicketColourSuffixes[];
    public readonly requiredAssets: ReadonlyArray<string>;
    public readonly extra: ReadonlyArray<ElementData> | undefined;

    constructor(pTerrain: ElementData, pBackgrounds: ElementData[], pDecorators: ElementData[],
                pGeneric: ElementData[], pUnique: ElementData[], pObstacles: ObstacleType[],
                pObstacleSpacing: PIXI.Point, pFlag: ElementData, pTicket: ElementData,
                pTicketColours: TicketColourSuffixes[], pExtra?: ElementData[]) {
        this.terrain = pTerrain;
        this.backgrounds = pBackgrounds;
        this.decorators = pDecorators;
        this.generic = pGeneric;
        this.unique = pUnique;
        this.obstacles = pObstacles;
        this.obstacleSpacing = pObstacleSpacing;
        this.flag = pFlag;
        this.ticket = pTicket;
        this.ticketColours = pTicketColours;
        this.extra = pExtra;
        this.requiredAssets = this.determineRequiredAssets();
    }

    private determineRequiredAssets(): string[] {
        const assets: string[] = new Array<string>();
        const elements: ElementData[] = new Array<ElementData>();
        elements.push(this.terrain);
        elements.push(...this.backgrounds);
        elements.push(...this.decorators);
        elements.push(...this.generic);
        elements.push(...this.unique);
        elements.push(this.flag);
        elements.push(this.ticket);
        if (this.extra !== undefined) {
            elements.push(...this.extra);
        }
        let asset: string;
        for (let i = 0; i < elements.length; ++i) {
            asset = this.getElementSourceAsset(elements[i]);
            if (assets.indexOf(asset) === -1) {
                assets.push(asset);
            }
        }
        // Don't include the common sheet. There seems to be a framework bug, need to look into it
        const commonIndex: number = assets.indexOf("terrain-common.json");
        if (commonIndex !== -1) {
            assets.splice(commonIndex, 1);
        }
        return assets;
    }

    private getElementSourceAsset(pElement: ElementData): string {
        if (pElement.sheet === undefined) {
            return pElement.asset + HLF.ResourceUtils.FILE_EXTENSION_PNG;
        }
        else {
            return pElement.sheet + HLF.ResourceUtils.FILE_EXTENSION_JSON;
        }
    }
}
